import React from "react";

//REDUX
import { useSelector } from "react-redux";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(theme => ({
  root: {
    position: "fixed",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 1050,
    background: "center no-repeat rgba(223, 125, 68, 0.3)"
  },
  spinner: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto"
  }
}));
//#endregion

export default function Loading() {
  const classes = useStyles();

  const loadingUser = useSelector(state => state.user.loading);

  const displayLoading = loadingUser ? (
    <div className={classes.root}>
      <CircularProgress
        className={classes.spinner}
        color="secondary"
        size={75}
      />
    </div>
  ) : null;

  return <React.Fragment>{displayLoading}</React.Fragment>;
}
